import React, {useState, useEffect, useRef} from 'react'
import { Button, Col, Row } from 'antd';
import dayjs from 'dayjs'

const DatePickerMobile = ({
    showDatePicker, 
    setShowDatePicker, 
    StyledDiv,
    formState,
    setFormState,
    setGeneralValidations
}) => {
    const daysRef = useRef(null);
    const monthsRef = useRef(null);

    const getCurrentYear = () => {
        const date = new Date();
        return date.getFullYear();
    };

    const year = getCurrentYear();
    const [months, setMonths] = React.useState([]);
    const [days, setDays] = React.useState([]);
    const [selectedData, setSelectedData] = useState({
        day: 0,
        month: 0,
        year: 0
    });
    const [error, setError] = useState(false);
    
    

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            const lastThreeMonths = getLastThreeMonths();
            setMonths(lastThreeMonths);
            const daysInMonth = getDaysInMonth(year, lastThreeMonths[0].month);
            setDays(daysInMonth);
            const formDate = parseDateString(formState.dateObserved);
            setSelectedData(formDate);

            
            centerSelectedItem(daysRef, formDate.day);
            centerSelectedItem(monthsRef, formDate.month);
        }

        return () => {  
            mounted = false;
        }
    }, [showDatePicker, formState.dateObserved, year]);

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            centerSelectedItem(daysRef, selectedData.day);
            centerSelectedItem(monthsRef, selectedData.month);
        }

        return () => {  
            mounted = false;
        }
    }, [selectedData]);

    const parseDateString = (dateString) => {
        const [year, month, day] = dateString.split('-').map(Number);
        return { day, month: month - 1, year };
    };
    
    const getLastThreeMonths = () => {
        const date = new Date();
        const currentMonth = date.getMonth();
        
        let months = [];
        for (let i = 0; i < 3; i++) {
          const month = new Date(date.getFullYear(), currentMonth - i, 1);
          months.push({
            year: month.getFullYear(),
            month: month.getMonth()
          });
        }
        return months.reverse();
    };

    const getDaysInMonth = (year, month) => {
        const date = new Date(year, month, 1);
        const days = [];
        
        while (date.getMonth() === month) {
          days.push(new Date(date).getDate());
          date.setDate(date.getDate() + 1);
        }
        return days;
    };

    const getMonthName = (monthIndex) => {
        const monthNames = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
        return monthNames[monthIndex];
    };

    const centerSelectedItem = (ref, selectedIndex) => {
        if (ref.current) {
            const selectedItem = ref.current.querySelector(`[data-index="${selectedIndex}"]`);
            if (selectedItem) {
                const container = ref.current;
                const containerHeight = container.clientHeight;
                const itemHeight = selectedItem.clientHeight;
                const itemOffsetTop = selectedItem.offsetTop;

                const scrollTo = itemOffsetTop - (containerHeight / 2) + (itemHeight / 2);
                container.scrollTop = scrollTo;
            }
        }
    };
    

    const handleSetDate = () => {
        const {day, month, year} = selectedData;
        let dateObserved = '';

        dateObserved += `${year}`;

        if(month < 10){
            if (month === 9)
                dateObserved += `-10`;
            else
                dateObserved += `-0${month + 1}`;
        }else{
            dateObserved += `-${month + 1}`;
        }

        if(day < 10){
            dateObserved += `-0${day}`;
        }else{
            dateObserved += `-${day}`;
        }

        const isValidDate = validateDateFormat(day, month, year);
        if (!isValidDate) {
            setError(true);
            return;
        }

        setFormState({...formState, dateObserved: dateObserved, defaultDate: dayjs(dateObserved)});
        setGeneralValidations(prevState => ({ ...prevState, dateObserved: "" }));
        setShowDatePicker(false);
    }

    const validateDateFormat = (day, month, year) => {
        const selectedDate = new Date(year, month, day);
    
        if (isNaN(selectedDate.getTime())) {
            return false;
        }
    
        return (
            selectedDate.getFullYear() === year &&
            selectedDate.getMonth() === month &&
            selectedDate.getDate() === day
        );
    };

  return (
    <>
        {showDatePicker && <div className="modal-overlay"
                style={{
                    height: "100dvh",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "end"
                }}
            >
                <Col 
                    xl={{span: 24}}
                    lg={{span: 24}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}} 
                    style={{
                        height: "55dvh",
                    }}

                >
                    <div className="modal"
                        style={{
                            height: "100%"
                        }}
                    >
                        <Row
                            style={{
                                marginBottom: "10px",
                                height: "15%",
                            }}
                        >
                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                }}
                            >
                                <Button
                                    onClick={() => {
                                        handleSetDate()
                                    }}
                                >Select</Button>
                            </Col>

                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "start",
                                    color: "red"
                                }}
                            >
                                {error && <StyledDiv>Invalid Date</StyledDiv>}
                            </Col>

                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                }}
                            >
                                <Button
                                    onClick={() => {
                                        setShowDatePicker(false)
                                        setError(false)
                                    }}
                                >Close</Button>
                            </Col>
                        </Row>

                        <Row
                            style={{
                                marginBottom: "10px",
                                height: "10%",
                            }}
                        >
                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontWeight: "600"
                                    }}
                                >Day</StyledDiv>
                            </Col>

                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontWeight: "600"
                                    }}
                                >Month</StyledDiv>
                            </Col>

                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontWeight: "600"
                                    }}
                                >Year</StyledDiv>
                            </Col>
                        </Row>
                        <hr/>

                        <Row
                            style={{
                                height: "60%",
                            }}
                        >
                            <Col
                                span={8}
                                className="scroll-container"
                                ref={daysRef}
                            >
                                {days.map((day, index) => {
                                    return(
                                        <Row
                                            key={day + index}
                                            data-index={day}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginBottom: "20px",
                                                paddingTop: index === 0 ? "75px" : "0px",
                                                paddingBottom: index === days.length - 1 ? "70px" : "0px",
                                                
                                                
                                            }}
                                        >
                                            <StyledDiv
                                                onClick={() => {
                                                    setSelectedData({...selectedData, day: day});
                                                    if (error) {
                                                        setError(false);
                                                    }
                                                }}
                                                style={{
                                                    fontSize: "16px",
                                                    color: selectedData.day === day ? 'rgb(174,32,114)' : 'black',
                                                    cursor: "pointer",
                                                }}
                                            >{day}</StyledDiv>
                                        </Row>
                                    )
                                })}
                            </Col>

                            <Col
                                span={8}
                                className="scroll-container"
                                ref={monthsRef}
                            >
                                {months.map((month, index) => {
                                    return(
                                        <Row
                                            key={month.month + index}
                                            data-index={month.month}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginBottom: "10px",
                                                paddingTop: index === 0 ? "75px" : "0px",
                                                paddingBottom: index === months.length - 1 ? "70px" : "0px",
                                                
                                            }}
                                        >
                                            <StyledDiv
                                                onClick={() => {
                                                    const daysInMonth = getDaysInMonth(year, month.month);
                                                    let day = selectedData.day;

                                                    if (day > daysInMonth) {
                                                        day = daysInMonth;
                                                    }

                                                    setDays(daysInMonth);
                                                    setSelectedData({...selectedData, day: -1, days: daysInMonth, month: month.month});
                                                    if (error) {
                                                        setError(false);
                                                    }
                                                    
                                                }}
                                                style={{
                                                    fontSize: "16px",
                                                    color: selectedData.month === month.month ? 'rgb(174,32,114)' : 'black',
                                                    cursor: "pointer",
                                                }}
                                            >{getMonthName(month.month)}</StyledDiv>
                                        </Row>
                                    )
                                })}
                            </Col>

                            <Col
                                span={8}
                                className="scroll-container2"
                            >
                                <Row
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    <StyledDiv
                                        style={{
                                            fontSize: "16px",
                                            color: "rgb(174,32,114)"
                                        }}
                                    >{year}</StyledDiv>
                                </Row>
                            </Col>
                        </Row>

                        <Row
                            style={{
                                marginBottom: "10px",
                                height: "15%",
                            }}
                        >
                            
                        </Row>
                        
                    </div> 
                </Col> 
            </div>} 
    </>
  )
}

export default DatePickerMobile
